import PaymentMethod from "./PaymentMethod";
import React from "react";
import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import getIsFree from "../utils/getIsFree";
import hasSupportedPaymentMethodFunction from "../utils/hasSupportedPaymentMethod";
import useIsDesktop from "../../../hooks/useIsDesktop";
import classNames from "classnames";

const PaymentMethods = ({
  currentCurrencyOfferByPeriod,
  availablePaymentMethods,
  translate,
  selectedPaymentMethod,
  setSelectedPaymentMethod
}) => {
  const isDesktop = useIsDesktop();
  const isFree = getIsFree({ currentCurrencyOfferByPeriod });
  const hasSupportedPaymentMethod = hasSupportedPaymentMethodFunction({
    availablePaymentMethods
  });

  return currentCurrencyOfferByPeriod && !isFree ? (
    <div
      className={classNames("flex shrink-0 gap-4", {
        "flex-row": isDesktop,
        "flex-col w-full": !isDesktop
      })}
    >
      {hasSupportedPaymentMethod ? (
        availablePaymentMethods.map(supportedPaymentMethod => {
          return (
            <PaymentMethod
              key={supportedPaymentMethod.name}
              onSelect={() => setSelectedPaymentMethod(supportedPaymentMethod)}
              images={supportedPaymentMethod.children}
              image={{
                src: supportedPaymentMethod.image,
                alt: supportedPaymentMethod.name
              }}
              name={supportedPaymentMethod.name}
              isSelected={
                selectedPaymentMethod?.name === supportedPaymentMethod.name
              }
            />
          );
        })
      ) : (
        <strong className={"text-xs text-black font-semibold"}>
          {translate("plans_payment-bar_no-payment-method")}
        </strong>
      )}
    </div>
  ) : null;
};

export default compose(withTranslations)(PaymentMethods);
